// frontend/src/services/academicYearService.js
import api from './api';

const API_PATH = '/academic-year';

export const getAllAcademicYears = async () => {
    const response = await api.get(API_PATH);
    return response.data;
};

export const createAcademicYear = async (yearData) => {
    const response = await api.post(API_PATH, yearData);
    return response.data;
};

// New API route: promote the current class and set a new current year
export const promoteToNewYear = async (newYearName) => {
    const response = await api.post(`${API_PATH}/promote`, { newYearName });
    return response.data;
};

export const setCurrentAcademicYear = async (yearId) => {
    const response = await api.put(`${API_PATH}/${yearId}/set-current`);
    return response.data;
};

export const updateAcademicYear = async (yearId, yearData) => {
    const response = await api.put(`${API_PATH}/${yearId}`, yearData);
    return response.data;
};